import React from 'react';
import styles from "./NextButton.module.scss";
import AbstractButton from '../abstractButton';

interface INextButtonProps {
  submitForm?: any;
  isSubmitting?: boolean;
  setSubmitRef?: any;
  setFieldValue?: any;
  activeStep?: number;
  steps?: string[],

  loading?: boolean;
}

const getNextStepLabel = ({
                            activeStep,
                            steps
                          }: any) => (activeStep >= 0 && Array.isArray(steps) && steps.length > activeStep) ? steps[activeStep + 1] : null;

export const isMaxStep = ({
                            activeStep,
                            steps
                          }: any) => (activeStep + 1) >= steps.length;

const Button = (props: any) => (<AbstractButton
  className={styles.nextButton}
  onClick={(e) => {
    props.setFieldValue("activeStep", props.activeStep + 1)
    props.submitForm(e);
  }}
  setSubmitRef={props.setSubmitRef}
  loading={props.loading}
>
  {props.children}
</AbstractButton>)

const NextButton = (props: INextButtonProps) => {
  if (isMaxStep(props)) {
    return (<Button
      {...props}
    >
      פרסם
    </Button>);
  } else {
    const step = getNextStepLabel(props);
    if (step) {
      return (<Button
        {...props}
      >
        {['המשך', ["ל", step].join("")].join(" ")}
      </Button>);
    }
  }
  return (null)
};

NextButton.defaultProps = {
  submitForm: () => {
  },
  isSubmitting: false,
  steps: [],
};

export default React.memo(NextButton);
